export default "__VITE_ASSET__BeCEkCET__"